import { COLORS } from "../../../presentation/constants/colors"
import React, { memo } from "react"

/**
 * Props for the WebsiteButton component.
 */
interface WebsiteButtonProps {
  /**
   * The URL to open when the button is clicked.
   */
  url: string

  /**
   * The label text displayed on the button.
   */
  label: string

  /**
   * Optional unique identifier for the button element.
   */
  id: string

  /**
   * Optional additional CSS classes for styling.
   */
  className?: string
}

/**
 * WebsiteButton component renders a button that opens a given URL in a new tab.
 *
 * @param {WebsiteButtonProps} props - The properties for the WebsiteButton component.
 * @returns {JSX.Element} The rendered website button.
 */
const WebsiteButton: React.FC<WebsiteButtonProps> = memo(
  ({ url, label, id, className = "" }) => (
    <button
      data-automation-id={id}
      id={id}
      onClick={() => window.open(url, "_blank")}
      style={{ '--hover-text-color': COLORS.DARK_BLUE } as React.CSSProperties}
      className={`border rounded-full px-6 py-2 text-sm transition-colors w-fit ${
        className ||
        "border-white text-white hover:text-[var(--hover-text-color)]"
      }`}
      aria-label={`Visit ${label} website`}
    >
      {label}
    </button>
  )
)

export default WebsiteButton
